// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class EventNode_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.EventNode';
  $t: string = 'SagaSchema.EventNode';

  public static GetMembers(): string[] {
    return [
      'Id',
      'EventId',
      'ParentId',
      'NodeType',
      'NodeDefinition',
      'NodeTag',
      'OutputNodeIds',
      'ProcedureId',
      'Priority',
      'InactivatedProcSteps',
      'ProcStepsReOrder',
      'ProcStepsComplements',
      'ProcedureName',
      'ProcedureInfo',
      'LastGroupRepeat',
      'FieldGeneric1',
      'FieldGeneric2',
      'FieldGeneric3'
    ].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return EventNode_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Id: number = 0;
  public EventId: number = 0;
  public ParentId: number;
  public NodeType: SagaBase.EventNodeType = SagaBase.EventNodeType.TerminalNode;
  public NodeDefinition: string;
  public NodeTag: string;
  public OutputNodeIds: string;
  public ProcedureId: number;
  public Priority: number;
  public InactivatedProcSteps: string;
  public ProcStepsReOrder: string;
  public ProcStepsComplements: string;
  public ProcedureName: string;
  public ProcedureInfo: string;
  public LastGroupRepeat: boolean = false;
  public FieldGeneric1: string;
  public FieldGeneric2: string;
  public FieldGeneric3: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.Id;
  }
  get ParentObjId(): any {
    return this.EventId;
  }
  set ParentObjId(value: any) {
    this.EventId = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
